import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useActiveLeagueContext } from '../../context/ActiveLeagueContext';

export const LeagueNotFoundGuard = ({ children }) => {
  const { activeLeague, isLoading, error } = useActiveLeagueContext();
  const { slug } = useParams();

  // On client-side navigation the provider keeps the previous league in state
  // (anti-flicker), so a resolved league only counts when it matches the URL slug.
  const leagueResolvedForSlug = Boolean(activeLeague?._id) && activeLeague?.slug === slug;

  if (
    slug &&
    !isLoading &&
    !leagueResolvedForSlug &&
    error?.response?.status === 404
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
};
